"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeFetchText = exports.timeFetch = exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _Input = _interopRequireDefault(require("./Input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// ----- UNTIL

var timeFetch = function timeFetch(time) {
  if (!time || typeof time !== 'string') return [0, 0];
  var x = time.replace('.', ':').split(':');
  var h = (0, _utils.num)(x[0]) || 0;
  var m = x.length === 1 ? 0 : (0, _utils.num)(x[1]);
  return [h > 23 || h < 0 ? 0 : h, m > 59 || m < 0 ? 0 : m];
};
exports.timeFetch = timeFetch;
var timeFetchText = function timeFetchText(time) {
  var _timeFetch = timeFetch(time),
    _timeFetch2 = _slicedToArray(_timeFetch, 2),
    h = _timeFetch2[0],
    m = _timeFetch2[1];
  return "".concat(h > 23 || h < 0 ? '00' : "".concat(h).padStart(2, '0'), ":").concat(m > 59 || m < 0 ? '00' : "".concat(m).padStart(2, '0'));
};

// ----- COMPONENT
exports.timeFetchText = timeFetchText;
function InputTime(props) {
  var _useState = (0, React.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var commitChange = function commitChange(v) {
    var vv = timeFetchText(v);
    setValue(vv);
    if (props.onChange) props.onChange(vv);
  };
  var inputProp = {
    className: (0, _utils.clsNames)('un-input-time', props.className, props.fixWidth && '-fix-width'),
    classBox: props.classBox,
    center: true,
    onChange: setValue,
    onBlur: commitChange,
    sm: props.sm,
    lg: props.lg
  };
  if (props.label) inputProp.label = props.label;
  if (!!props.icon) inputProp.icon = props.icon === true ? 'clock' : props.icon;
  if (props.form) inputProp.form = props.form;
  (0, React.useEffect)(function () {
    setValue(timeFetchText(props.value));
  }, [props.value]);
  return /*#__PURE__*/React.createElement(_Input.default, _extends({
    value: value
  }, inputProp));
}
var _default = InputTime;
exports.default = _default;